import { render } from "./ProductsAdmin.vue?vue&type=template&id=5b926c56"
import script from "./ProductsAdmin.vue?vue&type=script&lang=js"
export * from "./ProductsAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__